import { render, staticRenderFns } from "./EditSectionModal.vue?vue&type=template&id=2f2625c1&"
import script from "./EditSectionModal.vue?vue&type=script&lang=js&"
export * from "./EditSectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports